<template lang="pug">
y-dialog(v-model="showModal" fullscreen transition="fade-transition")
  v-container.bg-overlay(fill-height fluid @click.stop="clickCloseButton")
    v-container(fill-height @click.stop)
      v-layout(row wrap)

        v-flex.section-img(xs12)
          img.img-gallery(:src="getCurrentPhotoUrl()")      
          .section-close
            v-btn(@click="clickCloseButton" icon dark color="black")
              v-icon(color="white") mdi-close

          v-btn.btn-prev(color="black" dark fab small @click="clickPreviousButton" v-if="photos && photos.length > 1")
            v-icon mdi-chevron-left
          v-btn.btn-next(color='black' dark fab small @click="clickNextButton" v-if="photos && photos.length > 1")
            v-icon mdi-chevron-right

</template>

<script>

export default {
  props: ['photos', 'photoUrl', 'index', 'open'],
  data () {
    return {
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.open
      },
      set: function (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    currentPhoto () {
      return (this.photos) ? this.photos[this.index] : null
    },
    isSinglePhoto () {
      return this.photoUrl
    }
  },
  methods: {
    getCurrentPhotoUrl () {
      let currentPhotoUrl
      if (this.photos && this.photos.length > 0) {
        currentPhotoUrl = this.photos[this.index].url
      } else if (this.photoUrl) {
        currentPhotoUrl = this.photoUrl
      }
      return currentPhotoUrl
    },
    clickNextButton () {
      this.$emit('update:index', this.index + 1)
      if (this.index + 1 > this.photos.length - 1) {
        this.$emit('update:index', 0)
      }
    },
    clickPreviousButton () {
      this.$emit('update:index', this.index - 1)
      if (this.index - 1 < 0) {
        this.$emit('update:index', this.photos.length - 1)
      }
    },
    clickCloseButton () {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style scoped>

.img-gallery {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.section-img {
  background: #000;
  position: relative;
  height: 100%;
}

.bg-overlay {
  background-color: rgba(0, 0, 0, .75);
}

.btn-prev {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.btn-next {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.section-close {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
 }
</style>

